import type { App } from 'vue';
import { convertToBytes, fileSizeFormat, networkFormat } from './size';
import { clean, uppercase } from './text';
import { formatDate, fromNow } from './time';

export function installFilters(app: App) {
  app.config.globalProperties.$filters = {
    fromNow,
    formatDate,

    fileSizeFormat,
    convertToBytes,
    networkFormat,

    uppercase,
    clean
  };
}

export * from './size';
export * from './text';
export * from './time';
